import { Button } from "@mui/material"
import noop from "lib/noop"
import { useDarkMode } from "lib/use-dark-mode"

/**
 * A styled Mui button with theme warning colors, useful for in warning severity alerts.
 *
 * @param {string} text - The text printed inside the button.
 * @param {function} onClick - The function to run when the button is clicked.
 * @returns A pre styled Mui Button.
 */
export function WarningButton({ text, onClick = noop, sx, ...props }) {
    const isDark = useDarkMode()

    return (
        <Button
            sx={{
                color: isDark ? "warning.lighter" : "warning.darker",
                borderColor: isDark ? "warning.lighter" : "warning.darker",
                "&:hover": {
                    borderColor: isDark ? "warning.lighter" : "warning.darker",
                    backgroundColor: "#664D0314",
                },
                ...sx,
            }}
            variant="outlined"
            onClick={onClick}
            {...props}
        >
            {text}
        </Button>
    )
}
